export default "__VITE_ASSET__CWeTjAvj__"